class Lazy {
  constructor() {
    const targets = document.querySelectorAll('.lazy');

    const callback = (entries, observer) => {
      entries.forEach(({ target, isIntersecting }) => {
        target.addEventListener('load', () => {
          target.classList.add('lazy--loaded');
        });

        target.addEventListener('loadeddata', () => {
          target.classList.add('lazy--loaded');
        });

        if (isIntersecting) {
          target.dataset.src ? target.src = target.dataset.src :
          target.dataset.srcset ? target.srcset = target.dataset.srcset :
          target.dispatchEvent(new Event('load'));

          observer.unobserve(target);
        }
      })
    }

    const observer = new IntersectionObserver(callback);

    targets.forEach(target => observer.observe(target));
  }
}

export default Lazy;
